/* eslint-disable @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access */
import styled, { css } from 'styled-components';
import { Box } from '@rebass/grid';

import { variables, GridContainer, Image, Heading1 } from 'app/shared/ui';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const { media } = variables;

export const GridContainerSt = styled(GridContainer)`
  grid-template-rows: auto auto;
  color: ${({ theme: { colors } }) => colors.brandSecondaryLight};
`;

export const IntroContainerSt = styled.div`
  grid-row: 1;

  margin-bottom: 32px;
  padding: 0 12px;

  ${media.md(css`
    grid-column: 7 / span 6;

    display: flex;
    flex-direction: column;

    margin-bottom: 24px;
    padding: 0;
  `)}

  ${media.xl(
    css`
      // position in the parent grid
      grid-column: 6 / span 7;

      // own grid rules
      display: inline-grid;
      grid-template-columns: repeat(7, 1fr);
      column-gap: 32px;

      margin-bottom: 0;
    `,
  )}
`;

export const IFrameContainerSt = styled.div`
  grid-row: 2;

  ${media.md(css`
    grid-column: 1 / span 6;
    grid-row: 1;
  `)}
`;

export const TitleContainerSt = styled(Box)`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 16px;

  font-size: 48px;
  line-height: 64px;
  font-weight: bold;

  ${media.md(css`
    // position in the parent grid
    grid-row: 1;
    grid-column: 1 / span 6;

    display: block;

    font-size: 64px;
    line-height: 80px;
  `)}

  ${media.lg(css`
    font-size: 80px;
    line-height: 96px;
  `)}

  ${media.xl(css`
    grid-column-end: span 6;
  `)}
`;

export const TitleSt = styled(Heading1)`
  grid-row: 1;
  grid-column: 1 / span 12;
  font-weight: normal;

  font-size: 48px;
  line-height: 1.33;

  ${media.md(css`
    font-size: 64px;
    line-height: 1.25;
  `)}

  ${media.lg(css`
    font-size: 64px;
    line-height: 80px;
  `)}
`;

export const ListItemsContainerSt = styled.div`
  grid-row: 2;
  grid-column: 1 / span 6;

  ${media.xl(css`
    grid-column-end: span 7;
  `)}
`;

export const TitleWhiteSt = styled.span`
  display: inline-block;
  line-height: 1em;
  background-color: white;
  font-weight: bold;
`;

export const ImageContainerSt = styled.div`
  display: none;

  ${media.md(css`
    // position in the parent grid
    grid-row: 3;
    grid-column: 1 / span 6;

    // own grid rules
    display: inline-grid;
    grid-template-columns: repeat(6, 1fr);
    column-gap: 32px;
    grid-template-rows: 1fr;

    & > img:first-child {
      grid-column: span 2 / 7;

      grid-row: 1;
      justify-self: flex-end;
    }

    & > [title='tradein-hero-image'] {
      grid-column: 1 / span 6;
      grid-row: 1;

      margin-top: 12%;
    }

    margin-top: auto;

    max-width: 100%;
  `)}

  ${media.xl(
    css`
      grid-column-start: 2;
    `,
  )}
`;

export const CarSale24Form = styled.div`
  width: 100%;
  min-height: 660px;
  background-color: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;

  padding: 12px 12px 0;

  ${media.md(css`
    padding: 16px 16px 0;
  `)}

  ${media.lg(css`
    padding: 24px 24px 0;
  `)}

  ${media.xl(css`
    width: 468px;
    padding: 28px 28px 0;
  `)}
`;

export const BadgeMobileContainerSt = styled.div`
  grid-row: 1;
  grid-column: span 4 / 13;
  align-self: center;
  padding-top: 16%;

  ${media.md(
    css`
      display: none;
    `,
  )}
`;

export const Badge = styled(Image).attrs(() => ({
  src: '/assets/tradein/carsale24/badge.svg',
}))``;
